import { render, staticRenderFns } from "./ButtonSaleType.vue?vue&type=template&id=06f5c940&scoped=true&"
import script from "./ButtonSaleType.vue?vue&type=script&lang=js&"
export * from "./ButtonSaleType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f5c940",
  null
  
)

export default component.exports